import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material";
import { tokens } from "../layout/theme";

/**
 * A reusable loading indicator component with backdrop.
 * 
 * This component provides a full-screen loading overlay with:
 * - Animated circular progress indicator
 * - Semi-transparent backdrop
 * - Theme-based color scheme
 * - Smooth transition animation
 * 
 * @component
 * @example
 * ```tsx
 * <Loader />
 * ```
 * 
 * @remarks
 * - Uses Material-UI Backdrop and CircularProgress components
 * - Integrates with application theme
 * - Appears above other content (high z-index)
 * - Includes 500ms transition duration
 * - Uses theme's blue accent color
 * - Covers entire viewport
 * 
 * @returns {JSX.Element} A React component that renders a loading indicator
 */
const Loader = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <div>
      <Backdrop
        sx={{
          color: colors.blueAccent[300],
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={true}
        transitionDuration={500}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Loader;
